import { axiosClient } from "services/axios";

import {
  TDocItem,
  TDocItemsFilters,
  TDocument,
  TDocumentsFilters,
} from "../../../types/documents";
import { Item } from "../../../types";

export function getDocumentsRequest(obj: TDocumentsFilters = {}) {
  return axiosClient
    .get("documents/documents", {
      params: obj,
    })
    .then((res) => res.data as TDocument[])
    .catch((e) => console.warn(e?.message, "while getting documents"));
}

export function createDocumentRequest(obj: {
  operation_id: number | string;
}) {
  return axiosClient
    .post("documents/document", {
      operation_id: Number(obj.operation_id),
    })
    .then((res) => res.data as TDocument)
    .catch((e) => console.warn(e?.message, "while creating document"));
}

export function updateDocumentRequest(obj) {
  return axiosClient
    .put("documents/document", obj)
    .then((res) => res.data as TDocument)
    .catch((e) => console.warn(e?.message, "while updating document"));
}

export function deleteDocumentsRequest(obj: { docids: (number | string)[] }) {
  return axiosClient
    .post("documents/delete-documents", {
      docids: obj.docids.map((id) => Number(id)),
    })
    .then((res) => res.data as { message: "success" | string })
    .catch((e) => console.warn(e?.message, "while deleting documents"));
}

export function conductDocumentsRequest(obj: { docids: (number | string)[] }) {
  return axiosClient
    .post("documents/conduct", { docids: obj.docids.map((id) => Number(id)) })
    .then(
      (res) =>
        res.data as { message: "success" | string; errorMessages: string[] }
    )
    .catch((e) => console.warn(e?.message, "while conducting documents"));
}

export function unConductDocumentsRequest(obj: { docids: (number | string)[] }) {
  return axiosClient
    .post("documents/unconduct", {
      docids: obj.docids.map((id) => Number(id)),
    })
    .then((res) => res.data as { message: "success" | string })
    .catch((e) => console.warn(e?.message, "while un conducting documents"));
}

export function getItemsLeftAmountRequest(obj: {
  itemGroupIds: (number | string)[];
  docId: number | string;
}) {
  return axiosClient
    .post("documents/get-left-amount", {
      itemGroupIds: obj.itemGroupIds.map((id) => Number(id)),
      docId: Number(obj.docId),
    })
    .then((res) => res.data as Item[])
    .catch((e) => console.warn(e?.message, "while getting items left amount"));
}

/* ================ Doc Items ================*/
export function getDocItemsRequest(obj: TDocItemsFilters = {}) {
  return axiosClient
    .get("documents/get-docitems", {
      params: obj,
    })
    .then((res) => res.data as TDocItem[])
    .catch((e) => console.warn(e?.message, "while getting doc items"));
}

export function createDocItemsRequest(obj: { docitems: TDocItem[] }) {
  return axiosClient
    .post("documents/create-docitems", obj)
    .then((res) => res.data as { message: "success" | string })
    .catch((e) => console.warn(e?.message, "while creating doc items"));
}

export function updateDocItemsRequest(obj: { docitems: TDocItem[] }) {
  return axiosClient
    .put("documents/update-docitems", obj)
    .then((res) => res.data as { message: "success" | string })
    .catch((e) => console.warn(e?.message, "while updating doc items"));
}

export function deleteDocItemsRequest(obj: {
  docitemids: (number | string)[];
  docid: number | string;
}) {
  return axiosClient
    .post("documents/delete-docitems", {
      docitemids: obj.docitemids.map((id) => Number(id)),
      docid: Number(obj.docid),
    })
    .then((res) => res.data as { message: "success" | string })
    .catch((e) => console.warn(e?.message, "while deleting doc items"));
}

export function duplicateDocumentRequest(obj: {
  docid: number | string;
  newDocType: string;
}) {
  return axiosClient
    .post("documents/duplicate", {
      docid: Number(obj.docid),
      newDocType: obj.newDocType,
    })
    .then((res) => res.data as TDocument)
    .catch((e) => console.warn(e?.message, "while duplicating document"));
}

export function getItemLeftAmountRequest(obj: {
  itemid: number | string;
  docid: number | string;
}) {
  return axiosClient
    .get("items/left-amount", {
      params: { itemid: obj.itemid, docid: obj.docid },
    })
    .then((res) => res.data as number)
    .catch((e) => console.warn(e?.message, "while getting item left amount"));
}
